import React, {useState} from 'react';
import InertiaTable from 'laravel-inertia-react-table';
import {usePage} from '@inertiajs/react';
import ImportPositionsModal from './ImportPositionsModal.jsx';
import {Button, useEnhancedTranslation} from "laravel-inertia-backend";
import {PiMicrosoftExcelLogo} from "react-icons/pi";
import {WeclappIcon} from "../../Icons/WeclappIcon.js";
import CurrencyTableCell from "../../Components/CurrencyTableCell.jsx";
import TimestampTableCell from "../../Components/TimestampTableCell.jsx";
import HelpTooltip from "../../Components/HelpTooltip.jsx";

export default function Shipments(){
  const { shipments,weclappBaseUrl, col_definitions } = usePage().props;
  const [showModal,setShowModal] = useState(false);
  const [selectedDocumentId, setSelectedDocumentId] = useState(null);
  const {t} = useEnhancedTranslation();

  const openImportFor = (id) => {
    setSelectedDocumentId(id);
    setShowModal(true);
  }

    const openWeclappOrder = (id) => {
        window.open(`${weclappBaseUrl}app/shipment/${id}`, '_blank');
    }

  return (
    <>
      <InertiaTable
        key={'shipments-table'}
        data={shipments}
        title={
          <span className="d-inline-flex align-items-center gap-2">
            Verkauf - Lieferungen
            <HelpTooltip placement="right" size={0.95}>
              <div className="text-start">
                <strong>Welche Belege werden hier angezeigt?</strong>
                <div className="mt-1">Lieferungen aus Weclapp nach festen Regeln:</div>
                <ul className="mb-0 ps-3 mt-1">
                  <li>Belegtyp: <strong>Lieferung</strong> (Shipment) – alle Lieferarten (intern und normal)</li>
                  <li>Status: <strong>NEW</strong> – „wird erfasst", noch nicht abgeschlossen</li>
                </ul>
                <div className="mt-1">Sortierung: Liefernummer absteigend.</div>
              </div>
            </HelpTooltip>
          </span>
        }
        colDefinitions={[...col_definitions]}
        actionsDisplay={'column'}
        actions={[
            { icon: <PiMicrosoftExcelLogo />, alt: t('import from File'), callback: (data) =>openImportFor(data.id) },
            { icon: <WeclappIcon />, alt:  t('open in Weclapp'), callback: (data) =>openWeclappOrder(data.id) },

        ]}
        customCellRendererMap={{
        'orderDate': TimestampTableCell,
        'createdDate':TimestampTableCell
    }}
      />
      <ImportPositionsModal show={showModal} documentId={selectedDocumentId} documentType={'shipments'} onClose={()=>setShowModal(false)} />
    </>
  );
}
